<div data-test="editTreatment-editForm" [formGroup]="formGroup" class="text--label">
  <div class="flex--row flex--gutter flex--nowrap">
    <div class="flex__child--none">
      @if (!isLoading) {
        <mat-icon [style]="iconStyle" [color]="iconColor">{{ iconName }} </mat-icon>
      }
      @if (isLoading) {
        <mat-spinner diameter="20"></mat-spinner>
      }
    </div>
    <div class="flex__child">
      <div class="flex--gutter">
        <div class="flex__child flex--row flex--gutter no-vertical-padding flex--nowrap">
          <div class="flex__child--auto">
            <mat-form-field class="full-width-field flex__child">
              <mat-label>{{ 'manureSubstance' | translate }}</mat-label>
              <textarea
                type="text"
                style="resize: none"
                matInput
                formControlName="cropAidId"
                [matAutocomplete]="editProductAutocomplete"
                #newProductInput
                data-test="editTreatment-productFilter"
                (blur)="checkProduct()"
              ></textarea>
              <mat-autocomplete
                #editProductAutocomplete="matAutocomplete"
                [displayWith]="displayProduct()"
              >
                @for (option of filteredProducts; track option) {
                  <mat-option [value]="option.id" data-test="editTreatment-productOption">
                    {{ option.name }}
                    {{ getAdmissionNumberString(option.cropProtection?.admissions) }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="flex__child--auto">
            <mat-form-field class="full-width-field flex__child comment__input">
              <textarea
                matInput
                formControlName="comment"
                [placeholder]="'comments' | translate"
                data-test="editTreatment-comments"
              ></textarea>
            </mat-form-field>
          </div>
          @if (isAnimal) {
            <div class="flex__child flex--row flex--gutter flex--nowrap">
              <div class="flex__child max-width-container">
                <mat-form-field class="full-width-field">
                  <mat-label>{{ 'period' | translate }}</mat-label>
                  <mat-select
                    formControlName="periodId"
                    data-test="editTreatment-period-id"
                    panelWidth=""
                  >
                    @for (period of salesOrderPeriods$ | async; track period) {
                      <mat-option [value]="period.id">
                        {{ period.name }} ({{ period.startDispatchFrom | agrDate: 'shortDate' }}
                        {{ 'until' | translate }} {{ period.deliverBefore | agrDate: 'shortDate' }})
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="flex__child max-width-container">
                <mat-form-field class="full-width-field">
                  <mat-label>{{ 'soilType' | translate }}</mat-label>
                  <mat-select formControlName="soilTypeId" data-test="edit-cropfield-soilType">
                    @for (soilType of soilTypes$ | async; track soilType) {
                      <mat-option [value]="soilType.id">
                        {{ soilType.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
          @if (
            (formGroup.get('cropAidId').valid &&
              formGroup.get('soilTypeId').valid &&
              (!isFertilizerForm || formGroup.get('periodId').valid)) ||
            isBatchEdit
          ) {
            <div class="flex__child max-width-container">
              <mat-form-field class="full-width-field">
                <mat-label>
                  {{ 'dosage' | translate }}
                  {{ unitOfMeasurementDisplay }}
                </mat-label>
                <input
                  matInput
                  formControlName="dosage"
                  agrNumber
                  data-test="editTreatment-productDosage"
                  [step]="0.1"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
            <div class="flex__child max-width-container">
              <mat-form-field class="full-width-field">
                <mat-label> {{ 'totalNitrogen' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="totalNitrogen"
                  agrNumber
                  [placeholder]=""
                  data-test="editTreatment-totalNitrogen"
                  [step]="1"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
            <div class="flex__child max-width-container">
              <mat-form-field class="full-width-field">
                <mat-label> {{ 'totalPhosphate' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="totalPhosphate"
                  agrNumber
                  [placeholder]=""
                  data-test="editTreatment-totalPhosphate"
                  [step]="1"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="flex__child--none" style="margin-top: 6px">
      @if (isNotDelivered) {
        <button
          [disabled]="!canFertilizerMove()"
          (click)="moveToDelivered()"
          matTooltip="{{ 'moveToDelivered' | translate }}"
          color="primary"
          mat-icon-button
          type="button"
        >
          <mat-icon>check</mat-icon>
        </button>
      }
      @if (showDeleteButton) {
        <button
          color="warn"
          mat-icon-button
          type="button"
          (click)="delete()"
          matTooltip="{{ 'delete' | translate }}"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
